export default "__VITE_ASSET__BKMNIvog__"